export interface ITranslation {
  id: number;
  entityType: EntityTypeEnum;
  entityId: number;
  locale: string;
  field: string;
  value: string;
}

export enum EntityTypeEnum {
  SubscriptionPlan = 'SubscriptionPlan',
  Promotion = 'Promotion',
  Report = 'Report',
  UserFeedback = 'UserFeedback',
  Penalty = 'Penalty',
  Convention = 'Convention',
  ConventionForm = 'ConventionForm',
  Organization = 'Organization',
  Ente = 'Ente',
  PushNotification = 'PushNotification', 
  Zone = 'Zone',
  City = 'City',
  Hub = 'Hub',
  OperationalArea = 'OperationalArea',
  Model = 'Model',
  News = 'News'
}
